/** Always forward a target so gemi replaces any abandoned OAuth attempt's cookie. */
export function googleLoginUrl(
  intended: string,
  invitation?: { id: string; email: string },
): string {
  return `/auth/oauth/google?${new URLSearchParams({
    redirect: intended,
    ...(invitation && {
      "store-invitation-id": invitation.id,
      email: invitation.email,
    }),
  })}`;
}
